import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AppService } from '../app.service';
import { ConsumidorSiteClientModelService } from '../service/consumidorsiteclient.model.service';
import { ParametrosModelService } from '../service/parametros.model.service';
import {
  ConsClienteAPP,
  ConsumidorSiteResponseChaveConfirmacaoValida,
  ConsumidorSiteResponseGetConsumidorV0APP,
  DataParametrosAPP
} from '../vo/sitevo.vo';

@Component({
  selector: 'autenticacao',
  templateUrl: './autenticacao.component.html',
  styleUrls: ['./autenticacao.component.css']
})
export class AutenticacaoComponent implements OnInit {

  srcLogo: string = '';
  fantasia: string = '';

  constructor(
    private app: AppService,
    private cs: ConsumidorSiteClientModelService,
    private ps: ParametrosModelService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.srcLogo = this.app.lojaLogoBase64;
    this.fantasia = this.app.lojaFantasia;

    const tokenLS = window.localStorage.getItem(this.app.tokenLocalStorage);
    const cpfTokenLS = window.localStorage.getItem(this.app.cpfTokenLocalStorage);
    if (tokenLS && tokenLS.length > 0 && cpfTokenLS && cpfTokenLS.length > 0) {
      this.cs.isTokenValido(tokenLS)
        .then((data: ConsumidorSiteResponseChaveConfirmacaoValida) => {
          if (data.chaveConfirmacaoValida) {
            return this.cs.getDadosCliente(data.pkCliente.getPK());
          } else {
            return undefined;
          }
        })
        .then((data: ConsClienteAPP) => {
          if (data != null) {
            this.app.consCliente = data;
            return this.cs.getConsumidor(cpfTokenLS);
          } else {
            return undefined;
          }
        })
        .then((data: ConsumidorSiteResponseGetConsumidorV0APP) => {
          if (data != null) {
            this.app.consumidorSiteResponse = data;
            return this.ps.getParametrosApp();
          } else {
            return undefined;
          }
        })
        .then((data: DataParametrosAPP) => {
          if (data != null) {
            this.app.parametrosAPP = data;
            this.app.redirectOnLogin();
          } else {
            this.router.navigate(['/login']);
          }
        })
        .catch(error => {
          console.error(error);
          this.router.navigate(['/login']);
        });
    } else {
      this.router.navigate(['/login']);
    }
  }

}
